<template>
  <div id="app">
    <Header />
    <main>
      <router-view />
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body {
  margin: 0;
  background: #b0c4de;
}
main {
  height: calc(100vh - 134px);
  display: flex;
  align-items: center;
}
@media screen and (max-width: 767px) {
  main {
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue